import { render, staticRenderFns } from "./CardSelectedRecipes.vue?vue&type=template&id=6868ef54"
import script from "./CardSelectedRecipes.vue?vue&type=script&lang=js"
export * from "./CardSelectedRecipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports